import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { OctagonAlert, Plus } from 'lucide-react';
import { BowtieNode } from '../bowtie.types';

export const ConsequenceNode: React.FC<{
  data: BowtieNode & { onAddBarrier?: (consequence: BowtieNode) => void };
}> = memo(({ data }) => {
  return (
    <div
      style={{
        background: '#fef2f2',
        border: '2px solid #ef4444',
        borderRadius: '12px',
        padding: '12px 16px',
        width: '250px',
        minHeight: '108px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.1)',
        position: 'relative',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#b91c1c', fontWeight: 700, fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          <OctagonAlert size={14} />
          <span>CONSEQUENCE / HARM</span>
        </div>
        {data.onAddBarrier && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              data.onAddBarrier?.(data);
            }}
            title="Add a mitigation barrier for this consequence"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '3px',
              padding: '2px 7px',
              fontSize: '10px',
              fontWeight: 700,
              borderRadius: '6px',
              background: '#fee2e2',
              border: '1px solid #fca5a5',
              color: '#b91c1c',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
            }}
          >
            <Plus size={11} />
            Barrier
          </button>
        )}
      </div>

      <div style={{ fontWeight: 600, fontSize: '13px', color: '#7f1d1d', marginTop: '6px', lineHeight: 1.3 }}>
        {data.label}
      </div>

      <Handle id="left" type="target" position={Position.Left} style={{ background: '#ef4444', width: 8, height: 8 }} />
    </div>
  );
});
